import { render, staticRenderFns } from "./CardVenue.vue?vue&type=template&id=9e0485aa&scoped=true&"
import script from "./CardVenue.vue?vue&type=script&lang=js&"
export * from "./CardVenue.vue?vue&type=script&lang=js&"
import style0 from "./CardVenue.vue?vue&type=style&index=0&id=9e0485aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0485aa",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
